// This file is automatically generated by the "mapping" process

interface Mapping {
  [clientId: string]: string;
}

const mapping = {
  "8ErMS1Bc2DBOEntTajh3pNYKggd22aAI": "ikonapp",
  "0z8A2TTrsNsvssWMPnhctiYo4BEJp9Jx": "sno",
  Cox1fP8ihDFeoo0msuFK9ZijYUz2h1Ss: "crm",
  VGiF5KfY54E76Dvft7SjPlGwM4CcIGsY: "sb",
  AXtt9splKTCSezTUDb2Bug1B1lpcVrwq: "sol",
  getv8npbLwMfkOslwMPvKtwRNrOtGYQd: "str",
  QddULTrtSPp2eEpqQ0sgYA9G395Ochtq: "wp",
  "2MXw89TkHnn4mZUAFDTjeXDX4kMQ4K5T": "sb",
  e3pBaHW6vb8LtZtx7azaNQSR0pv65GOe: "sqa",
  "9zE1VXZE1XFVXtm2GSpgzKf8bj0viyU5": "qa",
  "2AlR9fEdiYR02IS3pMm84Q2x13YZwdnw": "ikon",
  uYfmIfxkRNlmhVOB4FmPS9duRwdSLC9u: "szm",
  ik0t1BtwOrH9LSLVxjUffC7JWXlXLGnP: "ikon",
  OU2WjFr7EOTzxjuWug97nwXI9NqI4lSz: "ikon",
  mFQpomFvGF3ClQKpOO3y4cBGBTLBVTOC: "ikon",
  "614Flh9Onnz3JZuGU3zsAJsE5rWdTJ7I": "ikon",
  wfvfCralAL6iqKuTOFgdolTWo5ztZRwF: "ikon",
  qmBhbCVCBzd4O5zMlf771igSL08oM87q: "ikon",
  anRZ1R7PRVqLOOYZs29ASKKUuq9xjdsH: "ikon",
  wBZPmQHhItqeqlPKGBwaqaXmjidevD9q: "ikon",
  oNLTM8bUzZyMdEQ88LAvnRHUSpQcW1zq: "aly",
  CIpz0GuL4zRAZPBLMq50mnpgVRsAfOcn: "ikon",
  "22S4BV8shi3uggHl0WfJHLavu5q8Dv7H": "aba",
  ocPnwr3VpLUAQgpdRlywf42gw5tECl3Y: "rvs",
  GXOUr1gqbysJetf3oukVSJFDRHGh42Hr: "sqa",
  gr543WaH9TOV7WReIcifns6Annr9BSM5: "ikon",
  GVRytra8b71qjX0Qg9gWora1lxbDKYEx: "wp",
  HpHodd9LKkevdQIGJwwlot1UyndP3Oa8: "ikon",
  cXh7PcRRglXTsBpytg5sNza3Y2MDcbom: "sol",
  M42ZYQ19ef9JEDOdlDS6KYeK12zdjdMM: "ikon",
  Mlk3oTXxS5sazNUqLRpBbE0NNILQSkCG: "sol",
  TeuzOaRLZCiAfr1fMSJdiMQum7MatRN9: "mam",
  LWrFx3Wvq8gygcubemfns4EhbjGtkCVN: "mam",
  "0SHVA86XochDu5KeW7qzkh9Qha2qLOvE": "trb",
  UxFVrdcOxmtuCZdwDJvHabZN6eVIxCJj: "sno",
  EsoY8FJzphmwFeYz9ptODNjHL7spYKnk: "ikon",
  z4unBLYVhOhiegtmnYjMregKxY2T9DQq: "crm",
  "2H9fZTUitHmMKmNu6JryiFe4nx4E0vDc": "bbm",
  T81stvByfVCXXByRFIJku5XTdsjFIxk8: "blm",
  repdjS21vAhZLRNuWZkM1oYtnm3PfwpM: "jun",
  upT6NyXWZpyJ0f5Az6pksopE2AwrykDW: "dvr",
  eI08pJc2ePcViNLqxpMzt79nRldVfGrz: "sb",
  guLJYmkBRZDxLclMDo5DPPYnvNuOoRht: "mam",
  EfQBri9OaOdSel8REaTXDrNOKcWcgjah: "sol",
  dXX4YpYQgJjDfreHWNmJx5kkKcamN0Wt: "sqa",
  wUOCHcMFXqn5jUH3qxKHJtjZOyuK0TkB: "str",
  "0VCmjFE8UydCIIjwbCD42BrYioOfLyWK": "sug",
  vI4Kbh16JO2NvgCrHVc4NB1H7xWaAuYM: "trb",
  CtQhVW6phOk8QhX7ukTVE4lXJyPS7vAj: "sno",
  ZnwGmk8ohWYAHTBrsV1GvrV0BQFbEP0D: "wp",
  "6BaAtQNFBWek7a7cCYYSkBwOTuJr86yq": "bbm",
  lV7sCdULB7YApR3nzDT7SU5qS1PI2tVI: "blm",
  fflPt2vKS8cf4f33hCkHhEpA5RRwKFj5: "crm",
  VSEISSQmhlujgVELD7eg9r1iq0Bi4oUC: "dvr",
  v2Wn7wZqBwR9VWBh3uSxflMNKFmRbVmj: "jun",
  "17vg63HgXd0MEqM5OzfDgga7UE8vHze3": "sb",
  EoVAWwXantpsmRLuuafe6Wr8zXn555Vb: "sno",
  FsfmGDfl1uh4pelbDaYouOXK2hHU3pdG: "sqa",
  rrQ69DYuyY9RwmDksRVpSa9dqiFKyayX: "sug",
  Ot3DkGsGGRH4mzdOSjQO92Uxg4GJyHr0: "str",
  mthzVr1nrfqroMeqKCoUBuLv9JO5Whwy: "wp",
  NFBlLRq8MVLVUzhvkG0wR4ZvQKGy5Ely: "trb",
  EE20PVxg7ZCb5KGTSgC3eGXGkqFmNUeh: "f&b",
  ZmoOcB06lOwEXKU64HyRT9r5EUjAmGhU: "ikon",
  VNmCEN7WEHjzcPRUwytTEVbuWDZPcWP6: "sb",
  "3rvaFdF670UKJxHwNTEWdpcvsoteD7g8": "trb",
  xTVzylko1LLL0kaSfOEzwjh9RsDVcYVC: "ikon",
  OGOyK6qwlmJ1GK4WGVBkwPcTqX6q2ZeF: "ikon",
  dqvrtG9oyu0hLubRN8FUkGOGqSAG5WKt: "ikon",
  "2AScZS1xGauOAb78vOVoUL9eJ5bTOrib": "ikon",
  O5zNexpbfgWAqJihGlQCEnsypJsS9Cgb: "ikon",
  F83Ck86gxyHgyEEPDFdPo3bsFTMqRXMg: "ikon",
  O6JBK1OWCKLze8osKb1SiON7V3VNBdl4: "ikon",
  pghVqKFi2IWvDhynzjTx2M015phsACeU: "ikon",
  sgwbONoNxy0enV3oQX413i78M8o8I4qT: "ikon",
  aKeS8TQ0DUofyvxAERnmI3gxljPbFMEN: "ikon",
  "78ckg5C2U0R0MQ0O6oc2GBzZa87Fm2Fx": "ikon",
  AcNhPGG9uVmUBUIRxPoz4kewBs0IGphs: "ikon",
  bKNlN8WxJgsSXKwyDqYkBoV14D3GZYLX: "ikon",
  hVJU0LmLno8MxxcdOnJlSPhO6hnT8h8g: "ikon",
  g5Z04mxh8EwM2j8SJr5VjxiUbPYVFLPo: "ikon",
  P9RYajP6S8kTxaD3FNqGwRcGY0xpTXaN: "dvr",
  TDFxrQnzeGi45fNRZwH7vk6HL6lKoVzm: "ikon",
  "9URUkKElu1oPpY8oK0WHawv7cyUnBHEk": "ikon",
  ml722qWwtq98OZdSuJyXMnYkQVgTSng1: "ikon",
  "61RJt4btLUum32wylHzbRKN3f0rfsC0D": "ikon",
  "35FqHuuciNvlemDzX4XL1JfjSx3C9ybh": "ikon",
  OtGjIdG2aZkNzekpGdi5tN45412UEnfO: "ikon",
  "2MqMQC9ZRBi15TEIxIkxgCkga7ejyvm8": "ikon",
  "9axfHEWwCVVDuUDPeEOQEAOpGxRuNNoy": "ikon",
  vh2fkmHFZ1fsZkdPbt1agpNNN1DOrvyi: "ikon",
  BtxhLXGYMyw9JarhrMsVpYr9KbPSvK2p: "ikon",
  "6wl9UPPOAJCMLeZm42ZxQpomOivjArek": "ikon",
  GfxgXO5CNM5T1rGsHam7VFG5RvAXWGJq: "ikon",
  AYAt12EtFX93oUvZvequkoNPNqmCJoem: "ikon",
  QOdFFNBZmx2pZ1JyiAVxRj2MBDlpxzmQ: "ikon",
  C9WhJu3AMKBuj2HSoCCC0JHl9i31Qm6L: "ikon",
  BNLDEVQkLRDpHQXyhG1ega6wT3zOirQ2: "ikon",
  ZDsndYnnt7DycSnzlTSLFZEnWW7J8S6D: "ikon",
  "1CCm5svBYPhCYd2IPxdVkT5en5HHwqZy": "ikon",
  "7zJ1JqPzEVui0fkNN5BTie6zXhxmU5IO": "sug",
} as Mapping;

export default mapping;
